var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutoCreateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tool_14203226 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.4122 18.8133L13.3616 11.2988L13.97 12.3128C14.1983 12.6933 14.1863 13.1541 13.9757 13.5258L20.5888 19.6986C20.7154 19.8161 20.7872 19.976 20.7904 20.1489C20.7936 20.3219 20.7278 20.4848 20.6057 20.6069C20.3607 20.8519 19.9331 20.8448 19.6959 20.5886L13.5281 13.9814C13.3449 14.0854 13.1408 14.1436 12.9333 14.1436C12.7197 14.1436 12.5049 14.087 12.3119 13.9713L11.2971 13.3624L18.8109 21.412C19.1579 21.7862 19.6492 22.0004 20.1595 22.0004C20.6508 22.0004 21.1127 21.8092 21.4603 21.4615C21.8171 21.1051 22.0083 20.6305 21.9988 20.1265C21.9894 19.6219 21.7808 19.1556 21.4122 18.8133Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.9333 13.5375C12.8267 13.5375 12.719 13.5091 12.6225 13.4513L9.91173 11.8247L7.20094 13.4513C6.96338 13.5941 6.65884 13.5569 6.4626 13.3604C6.26635 13.1645 6.22888 12.8599 6.37171 12.6221L7.9983 9.91126L6.37171 7.20047C6.22888 6.96262 6.26635 6.65807 6.4626 6.46212C6.65884 6.26677 6.96338 6.22899 7.20094 6.37123L9.91173 7.99783L12.6225 6.37123C12.861 6.22899 13.1649 6.26559 13.3609 6.46212C13.5571 6.65807 13.5946 6.96262 13.4518 7.20047L11.8252 9.91126L13.4518 12.6221C13.5946 12.8599 13.5571 13.1645 13.3609 13.3604C13.2443 13.4767 13.0897 13.5375 12.9333 13.5375ZM9.91173 10.5156C10.0194 10.5156 10.1269 10.5445 10.2228 10.6018L11.1715 11.1713L10.6023 10.2223C10.4875 10.0311 10.4875 9.79145 10.6023 9.60023L11.1715 8.65118L10.2228 9.22073C10.031 9.33523 9.79251 9.33523 9.6007 9.22073L8.65195 8.65118L9.2212 9.60023C9.33599 9.79145 9.33599 10.0311 9.2212 10.2223L8.65195 11.1713L9.6007 10.6018C9.69661 10.5445 9.80402 10.5156 9.91173 10.5156Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.91174 4.41747C9.57798 4.41747 9.30737 4.14715 9.30737 3.8131V2.60437C9.30737 2.27031 9.57798 2 9.91174 2C10.2455 2 10.5161 2.27031 10.5161 2.60437V3.8131C10.5161 4.14715 10.2455 4.41747 9.91174 4.41747Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.81316 10.5154H2.60443C2.27067 10.5154 2.00006 10.2451 2.00006 9.91101C2.00006 9.57695 2.27067 9.30664 2.60443 9.30664H3.81316C4.14692 9.30664 4.41753 9.57695 4.41753 9.91101C4.41753 10.2451 4.14692 10.5154 3.81316 10.5154Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.0542 10.5154H15.8455C15.5118 10.5154 15.2411 10.2451 15.2411 9.91101C15.2411 9.57695 15.5118 9.30664 15.8455 9.30664H17.0542C17.388 9.30664 17.6586 9.57695 17.6586 9.91101C17.6586 10.2451 17.388 10.5154 17.0542 10.5154Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.91174 17.6577C9.57798 17.6577 9.30737 17.3874 9.30737 17.0533V15.8446C9.30737 15.5105 9.57798 15.2402 9.91174 15.2402C10.2455 15.2402 10.5161 15.5105 10.5161 15.8446V17.0533C10.5161 17.3874 10.2455 17.6577 9.91174 17.6577Z",
    fill: "#232323"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoCreateIcon);
export default __webpack_public_path__ + "static/media/auto_create_icon.0291de129bbcac5009c03dd7e79e3680.svg";
export { ForwardRef as ReactComponent };